import { useState } from "react";
import apiJurados from "../api/Jurados/api-jurados";
import { Jurado, initialValuesModelJurado, ProyectoJurado } from "../models/JuradosModel/jurados.model";
import apiConvocatorias from "../api/Convocatorias/api-convocatorias";
import getStorageUser from "../middlewares/GetStorageUser"
import { reintentar } from "../utils/reintentar"

export const useInscribirHojaJurados = () => {
  const [jurado, setJurado] = useState<Jurado>(initialValuesModelJurado);
  const [proyectosJurado, setProyectosJurado] = useState<Array<ProyectoJurado>>([]);
  const [proyectosSeguimiento, setProyectosSeguimiento] = useState<any>([]);
  const [lineasConvocatorias, setLineasConvocatorias] = useState<any>([]);
  //console.log(stateredux);
  // agregado despues del push
  const [criteriosEvaluacion, setCriteriosEvaluacion] = useState<any>([]);

  const [messageNoJurado, setMessageNoJurado] = useState(false);
  const [errorConsultaJurado, setErrorConsultaJurado] = useState(false);

  /**
   * Trae los datos del jurado y distingue los dos casos que antes se veían iguales: que el
   * documento no corresponda a un jurado, y que la consulta no se haya podido hacer. Si falla,
   * reintenta antes de rendirse; si el token es el que ya no sirve, el interceptor de respuesta se
   * encarga de cerrar la sesión.
   */
  const consultarJurado = async () => {
    const user = getStorageUser();
    if (!user || !user.documento) {
      return;
    }

    try {
      const data = await reintentar(() => apiJurados.consultarJuradoPorDocumento(user.documento));

      setErrorConsultaJurado(false);

      if (!data || !data.length) {
        setMessageNoJurado(true);
        return;
      }

      setMessageNoJurado(false);
      setJurado(data[0]);
      try {
        let data2 = await apiJurados.obtenerCriterioJurado(data[0].id_jurado);
        setCriteriosEvaluacion(data2);
      } catch (err) {
        console.error("Error al obtener criterio jurado:", err);
      }
      try {
        let data3 = await apiConvocatorias.getLineaConvocatorias();
        setLineasConvocatorias(data3.data);
      } catch (err) {
        console.error("Error al obtener lineas convocatorias:", err);
      }
    } catch (error) {
      console.log(error);
      setMessageNoJurado(false);
      setErrorConsultaJurado(true);
    }
  };

  const consultarProyectosJurado = async () => {
    try {
      const user = getStorageUser();
      if (!user || !user.documento) return;
      let data = await apiJurados.getJuryByDocNumber(user.documento);
      if (Array.isArray(data) && data.length > 1 && data[1]) {
        setProyectosJurado(data[1].asignado || []);
        try {
          let data2 = await apiJurados.obtenerCriterioJurado(data[1].id_jurado);
          setCriteriosEvaluacion(data2);
        } catch (err) {
          console.error("Error al obtener criterio jurado:", err);
        }
      }
      try {
        let data3 = await apiConvocatorias.getLineaConvocatorias();
        setLineasConvocatorias(data3?.data || []);
      } catch (err) {
        console.error("Error al obtener lineas convocatorias:", err);
      }
    } catch (error) {
      console.error("Error en consultarProyectosJurado:", error);
    }
  };

  const consultarProyectoJuradoCriterioProyecto = async () => {
    try {
      const user = getStorageUser();
      if (!user || !user.documento) {
        return setProyectosSeguimiento([]);
      }
      let data = await apiJurados.obtenerCriterioProyectoJurado(user.documento);

      if (!data || data.message || !data.projectsall) {
        return setProyectosSeguimiento([]);
      }
      return setProyectosSeguimiento(data.projectsall);
    } catch (error) {
      console.error("Error al consultar proyectos jurado criterio:", error);
      setProyectosSeguimiento([]);
    }
  };

  const consultarHojadeVidaJuradoCriterioProyecto = async () => {
    try {
      const user = getStorageUser();
      if (!user || !user.documento) {
        return setProyectosSeguimiento([]);
      }
      let data = await apiJurados.obtenerCriterioHojadeVidaJurado(user.documento);
      if (!data || data.message || !data.projectsall) {
        return setProyectosSeguimiento([]);
      }
      return setProyectosSeguimiento(data.projectsall);
    } catch (error) {
      console.error("Error al consultar hojas de vida jurado criterio:", error);
      setProyectosSeguimiento([]);
    }
  };

  return {
    jurado,
    setJurado,
    proyectosJurado,
    consultarJurado,
    consultarProyectosJurado,
    consultarProyectoJuradoCriterioProyecto,
    criteriosEvaluacion,
    lineasConvocatorias,
    proyectosSeguimiento,
    messageNoJurado,
    errorConsultaJurado,
    consultarHojadeVidaJuradoCriterioProyecto
  };
};
